// extracted by mini-css-extract-plugin
module.exports = {"container":"CCWarningBadge__container___3qBw9","modal_container":"CCWarningBadge__modal_container___29mim"};